import VueI18n from "vue-i18n";
import Vue from "vue";
import tr from "./index.tr";
import en from "./index.en";
import ru from "./index.ru";
import de from "./index.de";
import fr from "./index.fr";
import es from "./index.es";
import ar from "./index.ar";
import it from "./index.it";

Vue.use(VueI18n);

const messages = {
    tr: tr.messages,
    en: en.messages,
    ru: ru.messages,
    de: de.messages,
    fr: fr.messages,
    es: es.messages,
    ar: ar.messages,
    it: it.messages,
};

export const langResources = messages;
// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: "en", // set locale
    fallbackLocale: "tr",
    messages, // set locale messages
});
